import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Avatar,
  Box,
  Link,
  CircularProgress,
  Grid,
} from "@mui/material";
import { GetTimeZone } from "../../_utilities/GetTimeZone";
import "./applicantCardNew.css";
import { useDispatch, useSelector } from "react-redux";
import {
  downloaddocumentAsync,
  downloaddocumentStartReducer,
} from "../../_redux/_services/ApplicantsSlice";
import Pagination from "../../components/DynamicTable/Pagination";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import { setBreadCrumb } from "../../_utilities/breadCrumb";

import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer"; // For DOC/DOCX viewing
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DynamicTable from "../DynamicTable/DynamicTable";
import { updateSnackbar } from "../../_redux/SnackbarSlice";
import SearchBar from "material-ui-search-bar";
import RightSideBar from "../Rightsidebar/RightSideBar";
import Cookies from "js-cookie";
import { safeJsonParse } from "../../_utilities/utilities";

const initalState = { data: null, message: "", isloader: true };

function ApplicantCardNew({ moduleType = "", data, selectedApplicantIds, associatedDocIds = {}, onReceiveProps, searchKeyWord="", totalRecordsProp }) {
  const [selectedDocId, setSelectedDocId] = useState("");
  const [docPath, setDocPath] = useState("");
  const [showDocument, setshowDocument] = useState("");
  const [docUrl, setDocUrl] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  let usersPerPage = (moduleType === "AssociatedApplicants" || moduleType === "FindAssociatedApplicants") ? 9 : 8;
  const [totalRecords, setTotalRecords] = useState(totalRecordsProp !== undefined ? totalRecordsProp : (data?.length || 0));
  const [jobData, setjobData] = useState([]);  // data ? (moduleType === "FindAssociatedApplicants" ? data : data.slice(0, usersPerPage)) :
  const [rawData, setRawData] = useState([]);  // data ||
  const [searchValue, setSearchValue] = useState(null);
  const searchValueTimeoutRef = useRef(null);
  const [selectedDocPerItem, setSelectedDocPerItem] = useState({});
  const [isSidePannel, setIsSidePannel] = useState(false);

  useEffect(() => {
    setSelectedDocPerItem({});
  }, [data]);

  useEffect(() => {
    return () => {
      if (searchValueTimeoutRef.current) {
        clearTimeout(searchValueTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (data) {
      setTotalRecords(totalRecordsProp !== undefined ? totalRecordsProp : data.length);
      if(moduleType === "FindAssociatedApplicants"){
        data?.forEach((list) => {
          if (list.docsarray && typeof list.docsarray === "string") {
            let formatVal = "[" + list.docsarray + "]";
            list.docsarray = JSON.parse(formatVal);
          } else if (!list.docsarray) {
            list.docsarray = [];
          }
          if (list.docsarray.length === 1) {
              list.docId = list.docsarray[0].docsid;
              list.docsId = list.docsarray[0].docsid;
              list.documentSubmittedBy = list.docsarray[0].submittedByName;
              list.documentName = list.docsarray[0].name;
              list.docscreatedDate = GetTimeZone(list.docsarray[0].docscreatedDate);
              list.fileType = list.docsarray[0].fileType;
              list.documentPath = list.docsarray[0].path;
            }
        });
      }
      setRawData(data);
      setjobData(moduleType === "FindAssociatedApplicants" ? data : data.slice(0, usersPerPage));
    } else {
      setTotalRecords(0);
      setRawData([]);
      setjobData([]);
    }
  }, [data, usersPerPage, totalRecordsProp, moduleType]);

  const dispatch = useDispatch();

  const docData = useSelector((state) => state.Downloaddocument.data);

  const handleShowResumes = (obj, isMultiDoc = false) => {
    if (isMultiDoc) {
      setshowDocument(showDocument === obj.id ? "" : obj.id);
      return;
    }
    if (selectedDocId !== obj.docsId) {
      setSelectedDocId(obj.docsId);
      dispatch(downloaddocumentAsync(obj.id, "preview", obj.docsId));
      setshowDocument(obj.id);
      setDocPath(obj.documentPath);
    } else {
      setshowDocument(showDocument ? "" : obj.id);
    }
  };

  useEffect(() => {
    if (docData) {
      setDocUrl(docData);
      dispatch(downloaddocumentStartReducer(initalState));
    }
  }, [docData]);

  const handleActionClick = (obj) => {
    let currentpage = obj - 1;
    let limitObj = {
      limit: usersPerPage,
      offset: currentpage * usersPerPage + 1,
      currentPage: obj,
      keyword: searchValue || "",
    };
    setCurrentPage(obj);
    
    if (moduleType === "FindAssociatedApplicants") {
      onReceiveProps(limitObj, "searchResult");
    } else {
      let DataNew = rawData;
      if (DataNew.length > usersPerPage) {
        let Data = DataNew.slice(currentpage * usersPerPage, obj * usersPerPage);
        setjobData(Data);
      } else {
        setjobData(DataNew);
      }
    }
  };
  // Get CSS variable for card width for doc viewer positioning
  const [cardWidth, setCardWidth] = useState(40);

  useEffect(() => {
    const getCardWidthFromCSS = () => {
      const root = document.documentElement;
      const value = getComputedStyle(root).getPropertyValue("--cardWidth");
      const parsed = parseFloat(value.trim());

      if (!isNaN(parsed)) {
        setCardWidth(parsed);
        console.log(parsed);
      }
    };

    getCardWidthFromCSS(); // Run on mount
    window.addEventListener("resize", getCardWidthFromCSS); // Update on resize

    return () => {
      window.removeEventListener("resize", getCardWidthFromCSS);
    };
  }, []);

  // const ext = (props.fileExtention || "").toLowerCase();

    const onSearchhandler = (value, type) => {
      value = value.trimStart();
      if (value.length < 2 && type === "onRequestSearch") {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Required Minimum 2 Characters",
          }),
        );
      }
      if (findconfiguration.isSearchServer === false) {
        const rawData = JSON.parse(rawData);
        if (value !== "") {
          value = value.trimStart();
          setSearchValue(value);
          if (rawData) {
            if (value.length > 1) {
              let data1 = rawData.filter((x) =>
                Object.keys(x).some((k) =>
                  String(x[k]).toLowerCase().includes(value.toLowerCase()),
                ),
              );
              if (data1.length > 0) {
                setTotalRecords(data1.length);
                setjobData(data1.slice(0, usersPerPage));
              } else {
                setjobData("");
              }
            } else {
              setjobData(rawData); // setjobData(rawData.slice(0, (usersPerPage)));
              setTotalRecords(rawData[0].total_count); //  setTotalRecords(rawData.length);
            }
            setCurrentPage(1);
          }
        } else if (value === "" && type === "onCancelSearch") {
          setCurrentPage(1);
          setjobData(rawData); // setjobData(rawData.slice(0, (usersPerPage)));
          setTotalRecords(rawData[0].total_count); //  setTotalRecords(rawData.length);
          setSelectedDocId('');
          setshowDocument('');
          setDocPath('');
        }
      } else if (findconfiguration.isSearchServer === true) {
        if (value !== "" && value.length >= 2) {
          value = value.trimStart();
          if (searchValueTimeoutRef.current) {
            clearTimeout(searchValueTimeoutRef.current);
          }
          searchValueTimeoutRef.current = setTimeout(() => {
            setSearchValue(value);
          }, 500);
          let limitObj = {
            limit: usersPerPage,
            offset: 1,
            currentPage: currentPage,
            keyword: value,
          };
          onReceiveProps(limitObj, "searchResult");
        } else if (value === "") {
          if (searchValueTimeoutRef.current) {
            clearTimeout(searchValueTimeoutRef.current);
            searchValueTimeoutRef.current = null;
          }
          setSelectedDocId('');
          setshowDocument('');
          setDocPath('');
          setSearchValue(value);
          setjobData([]);
          setCurrentPage(1);
          let limitObj = {
            limit: usersPerPage,
            offset: 1,
            currentPage: currentPage,
            keyword: value,
          };
          onReceiveProps(limitObj, "searchResult");
        }
      }
    };

  const onNavigeteInNew = (e, object) => {
    e.stopPropagation();
    let Name = "",
      type = "";
    if (object.applicantCode) {
      Name = object.firstName + " " + object.lastName;
      type = "Applicant Code";
    }
    setBreadCrumb(object.id, Name, type);
    window.open("/ats/layout/applicants/view/" + object.id, "_blank");
  };

  const getMarginLeft = (moduleType, index, cardWidth) => {

  const isAssociatedApplicants = moduleType === "AssociatedApplicants" || moduleType === "FindAssociatedApplicants";
  const isCardView = Cookies.get('jobPostingViewPreference')?.includes("list");

  // Non-AssociatedApplicants logic
  if (!isAssociatedApplicants) {
    if (index === 0 || index === 4) {
      return "0px";
    }

    if (index > 2) {
      const mod = index % 4;
      return `-${(mod === 0 ? 1 : cardWidth) * (mod === 0 ? 1 : mod === 1 ? mod + 0.01 : mod + 0.03)}%`;
    }

    return `-${cardWidth * (index + (index === 1 ? 0.01 : 0.03))}%`;
  }

  // AssociatedApplicants logic
  if (index === 0 || index === 3) {
    return "0px";
  }

  if (index > 2) {
    const mod = index % 3;

    return `-${
      (mod === 0 ? 0 : cardWidth) * ( mod === 0 ? 1 : mod === 1 ? mod + 0.01 : mod + (isCardView ? 0.025 : -0.012) )}%`;
  }

  return `-${cardWidth * (index + (index === 1 ? 0.01 : (isCardView ? 0.025 : -0.012) ))}%`; // -0.012
};

  // Returns the docsid (same type as docsarray items) for the associated document of a multi-doc item.
  const getAssocDocId = (item) => {
    if (moduleType !== "FindAssociatedApplicants" || (item?.docsarray?.length ?? 0) <= 1) return null;
    // 1. Selected in this session via radio
    if (selectedDocPerItem[item.id]?.docsid != null) return selectedDocPerItem[item.id].docsid;
    // 2. Stored association from parent (clientData.docsid)
    const storedId = associatedDocIds[item.id];
    if (storedId != null && storedId !== 0 && storedId !== "") return storedId;
    return null;
  };

  const getAssocDoc = (item) => {
    if (!selectedApplicantIds?.includes(item.id)) return null;
    const docId = getAssocDocId(item);
    if (docId == null) return null;
    return item.docsarray?.find(d => d.docsid === docId)
      ?? item.docsarray?.find(d => String(d.docsid) === String(docId))
      ?? null;
  };

  const isSidebarHidden = useSelector((state) => state.ui.isSidebarHidden);

  return (
      <>
       {moduleType === "FindAssociatedApplicants" && (
        <>
          <div className={ isSidebarHidden ? "FndApplicantsSearchbar-fullWidth" : "FndApplicantsSearchbar"} >
          <SearchBar
              className="FindAssociatedApplicants-searchbar"
              placeholder={searchKeyWord}
              // value={searchValue !== null ? searchValue : ''}
              onChange={(newValue) => onSearchhandler(newValue, "search")}
              onRequestSearch={(newValue) =>
                onSearchhandler(newValue, "onRequestSearch")
              }
              onCancelSearch={() => onSearchhandler("", "onCancelSearch")}
            />
          </div>
          {jobData !== "null" &&
          jobData !== null &&
          jobData !== undefined &&
          jobData.length > 0 ? (
            <div
              className="findAssociatedPagination"
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0px",
                alignItems: "center",
              }}
            >
              <h4 style={{ margin: 0, fontWeight: 700, color: "#4A4E54", fontSize: "18px" }}>Results</h4>
              
            </div>
          ) : (
            <>
            {searchValue && searchValue !== "" && jobData.length === 0 ? 
            <div className="noDataFoundsection">
              <img src="/ats/assests/nodata.svg" alt="" />
              <p>No applicants found</p>
            </div>
            : ""}
            </>
          )}
        </>
      )}
    <>
      {jobData.map((item, index) => (
          <Grid
            key={item.id ?? index}
            item
            xs={12}
            sm={6}
            md={(moduleType === "AssociatedApplicants" || moduleType === "FindAssociatedApplicants") ? 4 : 3}
            lg={(moduleType === "AssociatedApplicants" || moduleType === "FindAssociatedApplicants") ? 4 : 3}
            style={{ position: showDocument !== "" ? "static" : "relative" }}
          >
            <div
              id={selectedApplicantIds?.includes(item.id) ? "active" : ""}
              className={
                showDocument === item.id
                  ? "document-card cardSection"
                  : "cardSection"
              }
            >
              <aside
                className={
                  selectedApplicantIds?.includes(item.id) ? "active" : ""
                }
              >
                <div className="cardbgcolor">
                  <span className="cardbgcolor-name">
                    {item?.firstName} {item?.lastName}
                  </span>
                  {(moduleType === "AssociatedApplicants" || moduleType === "FindAssociatedApplicants") && (
                    <Link
                      onClick={(e) => {
                        onNavigeteInNew(e, item);
                      }}
                      type="button"
                      className="card-view-link"
                    >
                      <OpenInNewIcon className="newTab-btn" />
                      <span className="linkText">View</span>
                    </Link>
                  )}
                </div>
                <div>
                  <div style={{ display: "flex", marginTop: "-2px" }}>
                    <span>{item?.applicantCode}</span>
                  </div>
                  <p
                    style={{
                      cursor: "pointer",
                      height: "18px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "76%"
                    }}
                  >
                    {item.workExp && safeJsonParse(JSON.parse(item.workExp))[0]?.jobTitle}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "3px 00px 0px 0px",
                      gap: "10px",
                      alignItems: "baseline",
                    }}
                    className="recommendedresumecount"
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        mt: 1,
                        height: moduleType === "AssociatedApplicants" || moduleType === "FindAssociatedApplicants" ? "55px" :"90px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item?.matchedSkills?.map((skils) => (
                        <Chip label={skils} size="small" />
                      ))}
                    </Box>
                    {(() => {
                      // Single-doc: fields already set on item
                      if (item?.documentName && item?.fileType) {
                        return (
                          <>
                            <div style={{ justifyItems: "center", gap: "10px", display: "flex", height: "21px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {item.fileType === "pdf" ? (
                                <img src={process.env.PUBLIC_URL + "/assests/img/pdf.svg"} alt="" className="resumepdficon" />
                              ) : (
                                <img src={process.env.PUBLIC_URL + "/assests/img/docx.svg"} alt="" className="resumepdficon" />
                              )}
                              <span>{item?.documentName?.slice(0, 35)}{item?.documentName?.length > 35 && "..."} .{item.fileType}</span>
                            </div>
                            <i>{item.documentSubmittedBy}, {GetTimeZone(item.docscreatedDate)}</i>
                          </>
                        );
                      }
                      // Multi-doc associated: show the associated document details
                      const assocDoc = getAssocDoc(item);
                      if (assocDoc) {
                        return (
                          <>
                            <div style={{ justifyItems: "center", gap: "10px", display: "flex", height: "21px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {assocDoc.fileType === "pdf" ? (
                                <img src={process.env.PUBLIC_URL + "/assests/img/pdf.svg"} alt="" className="resumepdficon" />
                              ) : (
                                <img src={process.env.PUBLIC_URL + "/assests/img/docx.svg"} alt="" className="resumepdficon" />
                              )}
                              <span>{assocDoc.name?.slice(0, 35)}{assocDoc.name?.length > 35 && "..."} .{assocDoc.fileType}</span>
                            </div>
                            <i>{assocDoc.submittedByName}, {GetTimeZone(assocDoc.docscreatedDate)}</i>
                          </>
                        );
                      }
                      return <div style={{ justifyItems: "center", gap: "10px", display: "flex", height: "50px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}></div>;
                    })()}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Link
                        className="link-button"
                        onClick={(e) => {
                          const isMultiDoc = moduleType === "FindAssociatedApplicants" && item?.docsarray?.length > 1;
                          handleShowResumes(item, isMultiDoc);
                        }}
                      >
                        {showDocument === item.id
                          ? "Hide Resume"
                          : (moduleType === "FindAssociatedApplicants" && (item?.docsarray?.length ?? 0) > 1
                              ? `View ${item.docsarray.length} Resumes`
                              : (item?.docsarray?.length > 0 || moduleType === "AssociatedApplicants" || item?.docsId) ? "View Resume" : ""
                              )}
                      </Link>
                      
                        <button
                          className="normal-button"
                          onClick={(e) => {
                            const isAssociated = selectedApplicantIds?.includes(item.id);
                            const isMultiDoc = moduleType === "FindAssociatedApplicants" && item?.docsarray?.length > 1;
                            if (!isAssociated && isMultiDoc) {
                              const selectedDoc = selectedDocPerItem[item.id];
                              if (!selectedDoc) {
                                dispatch(updateSnackbar({ type: "error", message: "Please select a document to proceed" }));
                                return;
                              }
                              onReceiveProps({ ...item, docId: selectedDoc.docsid }, "Add");
                            } else {
                              if (isAssociated && isMultiDoc) {
                                setSelectedDocPerItem(prev => {
                                  const next = { ...prev };
                                  delete next[item.id];
                                  return next;
                                });
                              }
                              onReceiveProps(item, isAssociated ? "remove" : "Add");
                            }
                            setshowDocument(null);
                          }}
                        >
                          {selectedApplicantIds?.includes(item.id)
                            ? "Remove Applicant"
                            : "Add Applicant"}
                        </button>
                    </div>
                    {moduleType !== "FindAssociatedApplicants" && (
                      <div className="matchPercentageSection">
                        <CircularProgress
                          variant="determinate"
                          value={item.score * 100}
                          thickness={2}
                        />
                        <Box
                          top={0}
                          left={5}
                          bottom={10}
                          right={0}
                          position="absolute"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="caption">{`${Math.round(item.score * 100)}%`}</Typography>
                        </Box>
                      </div>
                    )}
                  </div>
                </div>
              </aside>
            </div>
            {docUrl !== null && showDocument === item.id && (moduleType !== "FindAssociatedApplicants" || item?.docsarray.length === 1) && (
              <div
                className={isSidebarHidden ? "document-preview-section-fullWidth" : "document-preview-section"}
                style={{
                  marginLeft: getMarginLeft(moduleType, index, cardWidth),
                  height: "80vh",
                }}
              >
                <DocumentViewer
                  key={docUrl}
                  url={docUrl}
                  fileType={(() => {
                    const cleanUrl = docUrl?.split("?")[0] || "";
                    return cleanUrl.split(".").pop()?.toLowerCase();
                  })()}
                  // onDownload={() => handleDownload(docUrl)}
                  // onDownload={() => {
                  //     props.onReceivechildProps(
                  //         { path: docPath, fileType: docUrl.split('.').pop().split('?')[0] },
                  //         "",
                  //         "download"
                  //     );
                  // }}
                />
              </div>
            )}
            {showDocument === item.id && moduleType === "FindAssociatedApplicants" && item?.docsarray.length > 1 && (
               <div className= {isSidebarHidden ? "document-preview-section-fullWidth" : "document-preview-section"}
                style={{ marginLeft: getMarginLeft(moduleType, index, cardWidth), 
                maxHeight: moduleType === "FindAssociatedApplicants" ? "80vh" : "none",
                height: moduleType === "FindAssociatedApplicants" ? "none" : "80vh",
                overflowY:"auto",
                position: isSidePannel ? "" : "relative"
                }}>

                <RenderResumeTable
                  applicantId={item.id}
                  documents={item.docsarray}
                  selectedId={getAssocDocId(item) ?? ""}
                  onDocSelect={(doc) => setSelectedDocPerItem(prev => ({ ...prev, [item.id]: doc }))}
                  isSidePannel={(val)=>setIsSidePannel(val)}
                />
              </div>
            )}
          </Grid>
      ))}
      {
      jobData !== "null" &&
      jobData !== null &&
      jobData !== undefined &&
      jobData.length > 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "10px 0px",
            alignItems: "center",
          }}
        >
          <p></p>
          <Pagination
            currentPage={currentPage}
            totalCount={totalRecords}
            pageSize={usersPerPage}
            onPageChange={(page) => handleActionClick(page)}
          />
        </div>
      ) : (
        ""
      )}
    </>
  </>
  );
}

export default ApplicantCardNew;


const RenderResumeTable = ({ documents, selectedId, onDocSelect, applicantId, isSidePannel }) => {

  const dispatch = useDispatch();
  const [actionType, setActionType] = useState("");
  const [previewType, setPreviewType] = useState();
  // const [selectedResume, setSelectedResume] = useState({});
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);

  const onReceiveActionHandler = async (type, object) => {
    if (type === "associateApplicant") {
      // setSelectedResume(object);
      if (onDocSelect) onDocSelect(object);
    } else if (type === "view") {
      DownloadFileFromS3(object, type);
      setIsRightSidePannel(true);
      isSidePannel(true);
    }
  }

    const docData = useSelector((state) => state.Downloaddocument.data);
    const [DocName, setDocName] = useState("");
  
    const DownloadFileFromS3 = async (object, type) => {
      type = type === "view" ? "preview" : ""; //"download"
      dispatch(downloaddocumentAsync(applicantId, type, object.docsid));
      setActionType(type);
      setDocName(object.path);
    };
  
    useEffect(() => {
      if (docData) {
        if (actionType === "Download" || actionType === "download") {
          const link = document.createElement("a");
          link.href = docData;
          link.download = DocName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setPreviewType(docData);
        }
        dispatch(downloaddocumentStartReducer(initalState));
      }
    }, [docData]);

    const onReceivePropsHandler = (pannel, load, type) => {
    if (type !== "") {
      setIsRightSidePannel(pannel);
      isSidePannel(pannel);
    } else if (type === "Download") {
      // DownloadFileFromS3(pannel, load);
    }
  };

  return (
    <>
      {documents && documents?.length > 0 && (
        <DynamicTable
          config={configuration}
          data={documents }
          selectedId={ selectedId }
          colmns={columnsData}
          actionDropdown={""}
          actions={actionsList}
          addModel={""}
          noDataText={"No documents found"}
          searchKeyWord="Search by Document Name"
          onReceiveActionProps={(type, obj) =>
            onReceiveActionHandler(type, obj)
          }
        />
      )}
      {documents.length === 0 && (
        <DynamicTable
          config={configuration}
          data={ documents }
          selectedId={ selectedId }
          colmns={columnsData}
          actionDropdown={""}
          actions={actionsList}
          addModel={""}
          noDataText={"No documents found"}
          searchKeyWord="Search by Document Name"
          onReceiveActionProps={(type, obj) =>
            onReceiveActionHandler(type, obj)
          }
        />
      )}

      {isRightSidePannel ? (
        <div id="tableResumeView">
          <RightSideBar
            componentData={
              <ComponentRenderData
                JobId={applicantId}
                previewType={previewType}
                DocName={DocName}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={pannelobj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : ("")}
    </>
  )
 }

 const ComponentRenderData = (props) => {

   const [url, setUrl] = useState(null);
   const dispatch = useDispatch();
 
   useEffect(() => {
     if (props.previewType !== "") {
       setUrl(props.previewType);
     }
   }, [props]);
 
   const downloadHandler = () => {
     // props.onReceivechildProps({docUrl:props.DocName}, "Download", "");
   };
 
   return (
     <>
       <div style={{ textAlign: "center" }}>
         {url !== null ? (
           <>
             <DocumentViewer
               url={url}
               fileType={(() => {
                 const cleanUrl = url?.split("?")[0] || "";
                 return cleanUrl.split(".").pop()?.toLowerCase();
               })()}
              //  style={{ width: "100%", height: "calc(100vh - 120px)" }}
             ></DocumentViewer>
             
           </>
         ) : (
           ""
         )}
       </div>
     </>
   );
 };


 const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: true,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 10,
  isPaginationTop: false,
  ischeckAlignRight: true,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: false,
};

const findconfiguration = {
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  limitData: 9,
  isSearchServer: true,
};

 // for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isPositingsView: true,
  isPostingsDownload: false,
  isDelete: false,
  isRadiobtn: true,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: "Document Name",
    mappingName: "name",
    class: "",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center doctablebodytext",
    isEdit: false,
    nagigate: null,
    width: "200px",
  },
  {
    id: 2,
    displayName: "Date and Time",
    mappingName: "docscreatedDate",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center doctablebodytext",
    isEdit: false,
    nagigate: null,
    width: "200px",
  },
  {
    id: 3,
    displayName: "Uploaded by",
    mappingName: "submittedByName",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center doctablebodytext",
    isEdit: false,
    nagigate: null,
    width: "200px",
  },
  {
    id: 4,
    displayName: "Action",
    mappingName: "Actions",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center documentposttime",
    isEdit: false,
    width: "150px",
    nagigate: null,
  },
];

const pannelobj = {
  title: "Document view",
  description: "",
  bgImage: "",
};